import { Component } from '@angular/core';
import { NavController,Events,IonicPage } from 'ionic-angular';
import { UtiltiyProvider } from '../../providers/utiltiy/utiltiy';
import { LoginPage } from '../login/login';
import { CrudProvider } from '../../providers/crud/crud';


@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {
  horizontalText:any = "";
  newsLiist:any = [];
  currentClass:any = null;
  slides = [
    {
      title: "Welcome to the Docs!",
      description: "The <b>Ionic Component Documentation</b> showcases a number of useful components that are included out of the box with Ionic.",
      image: "assets/imgs/klmr.png",
    },
    {
      title: "What is Ionic?",
      description: "<b>Ionic Framework</b> is an open source SDK that enables developers to build high quality mobile apps with web technologies like HTML, CSS, and JavaScript.",
      image: "assets/imgs/klmr.png",
    },
    {
      title: "What is Ionic Cloud?",
      description: "The <b>Ionic Cloud</b> is a cloud platform for managing and scaling Ionic apps with integrated services like push notifications, native builds, user auth, and live updating.",
      image: "assets/imgs/klmr.png",
    }
  ];
  constructor(public navCtrl: NavController,public utility:UtiltiyProvider,private api: CrudProvider,public events:Events) {
    // this.utility.setStorage("currentClass","home");
    // this.events.publish('currentClass',"home");
    this.getNews();
    this.currentClass = "home";
    this.navCtrl.swipeBackEnabled = false;

  }

  async getStatus(){
    // setTimeout(() => {
      this.horizontalText = ``;
    // }, 5000);
    // let currentGroup = await this.utility.getStorage("currentClass");
    // if(currentGroup){
    // this.currentClass = currentGroup;

    // }
  }

  getNews() {
    this.newsLiist = [];
    let string = "";
    this.api.get("/prestart/news/get", "false")
      .then((result: any) => {
        result.result.forEach(element => {
          string = string + `Subject: ${element.subject} Date: ${element.date} By:${element.username}     `

        });
        this.horizontalText = string;
        this.newsLiist = result.result;
        console.log("result", this.newsLiist)
        console.log("this.horizontalText ", this.horizontalText)
      }, err => {
      })
  }

  dateConvert(date) {

    if (date) {
      let dateString = date.split("-");
      return dateString[2] + "-" + dateString[1] + "-" + dateString[0]
    } else {
      return "";
    }

  }

  selectType(){
    // this.currentClass = type;
    // console.log("typw",this.currentClass);
    // this.utility.setStorage("currentClass",type);
    // this.events.publish('currentClass',type);
    this.navCtrl.setRoot(LoginPage);

  }

}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts